export const WHISPER_CONFIG = {
  model: 'Xenova/whisper-tiny',
  task: 'automatic-speech-recognition',
  cache_dir: '.cache',
  quantized: true,
};

export const isWebAssemblySupported = (): boolean => {
  try {
    if (typeof WebAssembly === 'object' && typeof WebAssembly.instantiate === 'function') {
      const module = new WebAssembly.Module(
        Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00)
      );
      return module instanceof WebAssembly.Module;
    }
    return false;
  } catch {
    return false;
  }
};

export const initTransformersConfig = () => {
  try {
    if (typeof window !== 'undefined' && isWebAssemblySupported()) {
      (window as any).transformersConfig = {
        cacheDir: '.cache',
        allowRemoteModels: true,
        allowLocalModels: true,
      };
    }
  } catch (err) {
    console.error('Failed to initialize transformers config:', err);
  }
};

initTransformersConfig();
